import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import TelaPermissao from "../../../../Base/Permissao/TelaPermissao";
import TituloMovimentacaoConsultaScreen from "./TituloMovimentacaoConsultaScreen";
import TituloMovimentacaoForm from "./TituloMovimentacaoForm";
import MovimentacaoEditarScreen from "../../Conta/Movimentacao/MovimentacaoEditarScreen";
import MovimentacaoVisualizar from "../../Conta/Movimentacao/MovimentacaoVisualizar";

export interface ITituloMovimentacaoScreenProps {
    codTitulo : number;
}
export default function TituloMovimentacaoScreen({
    codTitulo
}:ITituloMovimentacaoScreenProps) {
    const navigate = useNavigate();

    return <Routes>
        <Route path="/" element={<Outlet />}>
            <Route
                path="/"
                index 
                element={
                    <TelaPermissao permissoes={["FinanceiroContaMovimentacaoListarPorTitulo"]}>
                        <TituloMovimentacaoConsultaScreen codTitulo={codTitulo} />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/Movimentacao/Novo"
                element={
                    <TelaPermissao permissoes={["FinanceiroContaMovimentacaoInserir"]}>
                        <TituloMovimentacaoForm codTitulo={codTitulo} onCancelar={() => navigate(-1)} />
                    </TelaPermissao>
                }
            ></Route>
            <Route path="/Movimentacao/Editar/:codigo" element={
                <TelaPermissao permissoes={["FinanceiroContaMovimentacaoAlterar"]}>
                    <MovimentacaoEditarScreen
                        onCancelar={() => navigate(-1)}
                    />
                </TelaPermissao>
            }></Route>
            <Route path="/Movimentacao/Visualizar/:codigo" element={
                <TelaPermissao permissoes={["FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                    <MovimentacaoVisualizar
                        onCancelar={() => navigate(-1)}
                    />
                </TelaPermissao>
            }></Route>
        </Route>
    </Routes>;
}